/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmContractVerifyInfo = {
    STS: EvmContractVerifyInfo.STS;
    CTRTADDR: string;
    MSG: string;
    VA: number;
    NM: string;
    BTCD: string;
    ABI: string;
};

export namespace EvmContractVerifyInfo {

    export enum STS {
        Y = 'Y',
        N = 'N',
    }


}

